import firebase from "firebase";
import { db, auth } from "../../Firebase/firebase";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import router from "../../router/index";
import { Date } from "core-js";
import Vue from "vue";
import {baseurl} from "../../helpers/helper"



const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);

export default {
  namespaced: true,

  state: {
    isLoggingIn: false,
    ToastArray: [],
    userProfile: "",
    uploadValue: [],
    menus: [],
    currentMenu: null,
    currentCategory: null,
    items: {},
    notifications: [],
    notificationsCount: { total: 0 },
    menuCategories: [],
  },

  getters: {},

  mutations: {
    UPDATE_UPLOAD_VALUE(state, { index, name, progress }) {
      const fileIndex = state.uploadValue.findIndex((x) => x.index === index);
      if (fileIndex === undefined || fileIndex === -1) {
        state.uploadValue.push({ index, name, progress });
      } else {
        state.uploadValue[fileIndex].progress = progress;
      }
    },
    RESET_UPLOAD_VALUE(state) {
      state.uploadValue = [];
    },
    UPDATE_BACKGROUND_IMG(state, value) {
      state.backgroundURL = value;
    },
    SET_MENUS(state, data) {
      state.menus = data;
    },
    SET_CURRENT_MENU(state, data) {
      data.data().categories.map((item) => {
        if (!state[item.name]) {
          Vue.set(state, item.name, []);
        }
      });
      state.currentMenu = { ...data.data(), id: data.id };
    },
    SET_CATEGORY(state, category) {
      if (!state[category]) {
        Vue.set(state, category, []);
      }
    },
    SET_CURRENT_CATEGORY(state, category) {
      state.currentCategory = category;
    },
    SET_ITEMS(state, { data, category }) {
      state[category] = state[category] ? state[category] : [];
      state[category].push(data);
    },
    ADD_TO_TOAST(state, data) {
      state.ToastArray.push(data);
    },
    REMOVE_ITEM_FROM_TOAST(state, index) {
      const newToastArray = state.ToastArray;
      newToastArray.splice(index, 1);
      state.ToastArray = newToastArray;
    },
    SET_MENU_CATEGORIES(state, { data }) {
      state.menuCategories = [...data];
    },
    FETCHING_ITEMS(state, status) {
      state.fetchingItems = status;
    },
    ...vuexfireMutations,
  },

  actions: {
    setCurrentCategory({ commit }, category) {
      commit("SET_CURRENT_CATEGORY", category);
    },

    async uploadPhoto({ commit, dispatch }, { file, index }) {
      const storageRef = firebase
        .storage()
        .ref(`${file.name}`)
        .put(file);
      await storageRef.on(
        `state_changed`,
        (snapshot) => {
          commit("UPDATE_UPLOAD_VALUE", {
            index,
            name: file.name,
            progress: (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
          });
        },
        (error) => {
          const data = {
            title: "Error",
            message: error.message,
          };
          commit("ADD_TO_TOAST", data);
        }
      );
      return storageRef;
    },

    async getImgUrl({ commit, dispatch }, storageRef) {
      const img = await storageRef.ref.getDownloadURL().then((url) => {
        return url;
      });
      return img;
    },

    async getUrlArray({ commit, dispatch }, files) {
      const urlArray = files.map(async (file, index) => {
        const storageRef = await dispatch("uploadPhoto", { file, index });
        const url = await dispatch("getImgUrl", storageRef);
        return url;
      });

      return await Promise.all(urlArray);
    },

    resetUploads({ commit }) {
      commit("RESET_UPLOAD_VALUE");
    },

    async createItem({ commit, dispatch }, { file, menuId, form, category }) {
      const urlArray = await dispatch("getUrlArray", file);
      db.collection("menusItems")
        .doc(menuId)
        .collection("menuItems")
        .add({
          ...form,
          img: urlArray,
          category,
          createdAt: new Date(),
          is_active: true,
          ownerId: auth.currentUser.uid,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully created item",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
          dispatch("changeMenuItemsCount", { action: "increase", menuId });
          dispatch("fetchItems", { menuId, category });
        });
    },

    async createMenu({ commit, dispatch }, { file, form, userProfile }) {
      const urlArray = await dispatch("getUrlArray", file);
      const qrcodeUrl = `https://chart.googleapis.com/chart?cht=qr&chs=400x400&chl=${encodeURIComponent(
        `${baseurl}/${userProfile.company_name.replace(
          " ",
          ""
        )}/${form.menu_name.replace(/ /, "")}`
      )}`;
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .add({
          ...form,
          backgroundURL: urlArray,
          createdAt: new Date(),
          categories: [],
          is_active: true,
          qrcodeUrl: qrcodeUrl,
          "--count--": { item_count: 0 },
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully created menu",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
        });
    },

    async createCategory({ commit, dispatch }, { menuId, form }) {
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          categories: firebase.firestore.FieldValue.arrayUnion({
            name: form.category,
            title: form.category,
            description: form.description,
            is_active: true,
            item_count: 0,
          }),
        })
        .then((response) => {
          const data = {
            title: "Success",
            message: "Successfully created category",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
          dispatch("fetchMenu", { auth, menuId });
        });
    },

    async fetchMenus({ commit, dispatch }, auth) {
      await db
        .collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .where("is_active", "==", true)
        .orderBy("createdAt", "desc")
        .onSnapshot((snapshot) => {
          let menusArray = [];

          snapshot.forEach((doc) => {
            let post = doc.data();
            post.id = doc.id;

            menusArray.push(post);
          });
          commit("SET_MENUS", menusArray);
        });
    },
    async fetchMenu({ commit, dispatch, state }, { menuId }) {
      if (!state.currentMenu) {
        const menu = await db
          .collection("menus")
          .doc(auth.currentUser.uid)
          .collection("userMenus")
          .doc(menuId)
          .get();
        commit("SET_CURRENT_MENU", menu);
        return menu.data();
      } else if (state.currentMenu.id !== menuId) {
        const menu = await db
          .collection("menus")
          .doc(auth.currentUser.uid)
          .collection("userMenus")
          .doc(menuId)
          .get();
        commit("SET_CURRENT_MENU", menu);
        return menu.data();
      }
    },

    async fetchCategory(
      { commit, dispatch, state },
      { menuId, categoryTitle }
    ) {
      if (!state.currentCategory) {
        const menu = await db
          .collection("menus")
          .doc(auth.currentUser.uid)
          .collection("userMenus")
          .doc(menuId)
          .get();

        const category = menu
          .data()
          .categories.find((x) => x.title === categoryTitle);
        commit("SET_CURRENT_MENU", menu);
        commit("SET_CURRENT_CATEGORY", category);
      }
    },

    fetchItems: firestoreAction(
      (
        { commit, dispatch, state, bindFirestoreRef },
        { menuId, category, limit }
      ) => {
        commit("SET_CATEGORY", category);
        return bindFirestoreRef(
          category,
          db
            .collection("menusItems")
            .doc(menuId)
            .collection("menuItems")
            .where("category", "==", category)
            .where("is_active", "==", true)
            .orderBy("createdAt", "desc")
            .limit(limit)
        );
      }
    ),

    fetchNotificationsCount: firestoreAction(
      ({ commit, dispatch, bindFirestoreRef }) => {
        //commit("SET_CATEGORY", category);
        return bindFirestoreRef(
          "notificationsCount",
          db
            .collection("notifications")
            .doc(auth.currentUser.uid)
            .collection("notification")
            .doc("--count--")
        );
      }
    ),

    fetchNotifications: firestoreAction(
      ({ commit, dispatch, bindFirestoreRef }) => {
        //commit("SET_CATEGORY", category);
        return bindFirestoreRef(
          "notifications",
          db
            .collection("notifications")
            .doc(auth.currentUser.uid)
            .collection("notification")
            .where("is_active", "==", true)
            .orderBy("timestamp", "desc")
        );
      }
    ),

    async editMenu(
      { commit, dispatch },
      { form, backgroundURL, file, menuId }
    ) {
      const urlArray = await dispatch("getUrlArray", file);
      const newUrlArray = [...new Set([...backgroundURL, ...urlArray])];
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          ...form,
          backgroundURL: newUrlArray,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully updated menu",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
        });
    },

    async updateQrcode({ commit, dispatch }, { qrcodeUrl, menuId }) {
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          qrcodeUrl: qrcodeUrl,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Regenerated Qr Code",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
          dispatch("fetchMenu", { menuId });
        });
    },

    async deleteMenu({ commit, dispatch }, menuId) {
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          is_active: false,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully deleted menu",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
        });
    },

    async editCategory({ commit, dispatch }, { categories, menuId }) {
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          categories,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully updated category",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
        });
    },

    async deleteCategory({ commit, dispatch }, { categories, menuId }) {
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          categories,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully deleted category",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
        });
    },

    async editMenuItem(
      { commit, dispatch },
      { form, images, menuId, itemId, file }
    ) {
      const urlArray = await dispatch("getUrlArray", file);
      const newUrlArray = [...new Set([...images, ...urlArray])];
      db.collection("menusItems")
        .doc(menuId)
        .collection("menuItems")
        .doc(itemId)
        .update({
          ...form,
          img: newUrlArray,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully updated menu item",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
        });
    },

    async removecategoryFromMenu(
      { commit, dispatch },
      { newCategory,menuId }
    ) {
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          categories:newCategory
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully updated menu item",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data);
        });
    },

    async changeMenuItemsCount(
      { commit, dispatch, state },
      { action, menuId }
    ) {
      const implement = action === "increase" ? increment : decrement;
      const category = {
        ...state.currentCategory,
        item_count:
          action === "increase"
            ? state.currentCategory.item_count + 1
            : state.currentCategory.item_count - 1,
      };
      const index = state.currentMenu.categories.findIndex(
        (x) => x.name === category.name
      );
      const categories = [...state.currentMenu.categories];
      categories[index] = category;
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          "--count--.item_count": implement,
          categories: categories,
        });
    },

    async deleteMenuItem({ commit, dispatch }, { menuId, itemId }) {
      db.collection("menusItems")
        .doc(menuId)
        .collection("menuItems")
        .doc(itemId)
        .update({
          is_active: false,
        })
        .then(() => {
          const data = {
            title: "Success",
            message: "Successfully deleted menu item",
            variant: "success",
          };
          dispatch("changeMenuItemsCount", { action: "decrease", menuId });
          commit("ADD_TO_TOAST", data);
        });
    },

    async addCategoryToMenu({ commit }, { menuId, categories }) {
      db.collection("menus")
        .doc(auth.currentUser.uid)
        .collection("userMenus")
        .doc(menuId)
        .update({
          categories: firebase.firestore.FieldValue.arrayUnion(...categories),
        })
        .then((response) => {
          const data = {
            title: "Success",
            message: "Successfully added categories(s)",
            variant: "success",
          };
          commit("ADD_TO_TOAST", data, { root: true });
          return response;
        });
    },

    async fetchMenuCategories({ commit }, { categories, companyId }) {
      const uid = companyId ? companyId : auth.currentUser.uid;
      commit("FETCHING_ITEMS", true);
      const response = db
        .collection("categories")
        .doc(uid)
        .collection("userCategories")
        .where(firebase.firestore.FieldPath.documentId(), "in", categories)
        .onSnapshot((snapshot) => {
          let itemsArray = [];

          snapshot.forEach((doc) => {
            let post = doc.data();
            post.id = doc.id;

            itemsArray.push(post);
          });

          commit("FETCHING_ITEMS", false);
          commit("SET_MENU_CATEGORIES", {
            data: itemsArray,
          });
        });

      return response;
    },

    removeToast({ commit }, index) {
      commit("REMOVE_ITEM_FROM_TOAST", index);
    },
  },
};
